import PushNotificationIndex from './PushNotificationIndex';
import PushNotificationCreate from './PushNotificationCreate';
import PushNotificationSettings from './PushNotificationSettings';
import PushNotificationSingle from './PushNotificationSingle';

export default function (app) {

    const settings = PushNotificationSettings;

    app.addModel({
        name: settings.key,
        path: settings.path,
        modelName: settings.modelName,
        endpoint: settings.endpoint,
        idKey: settings.idKey,
        primaryKey: settings.primaryKey,
    });

    // app.addMenu({
    //     key: settings.key,
    //     zone: settings.zone,
    //     label: settings.title,
    //     priority: 14,
    //     items: [
    //         {
    //             label: "All",
    //             path: settings.path,
    //             caps: settings.indexCaps
    //         },
    //         {
    //             label: "Add New",
    //             path: settings.path + "/create",
    //             caps: settings.createCaps
    //         }
    //     ],
    // });

    PushNotificationIndex(app, settings);

    PushNotificationCreate(app, settings);

    PushNotificationSingle(app, settings);

}